"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Secondary = exports.Primary = void 0;
var Primary;
(function (Primary) {
    Primary.orange = {
        '100': '#FA6400',
        '80': '#F88030',
        '60': '#F79D61',
        '40': '#F5B991',
        '20': '#F4D6C2',
        '10': '#F3E4DA',
        '5': '#F2EBE6',
    };
    Primary.navy = {
        '100': '#163250',
        '80': '#455B73',
        '60': '#738496',
        '40': '#A2ADB9',
        '20': '#D0D6DC',
        '10': '#E7EAED',
        '5': '#F3F5F6',
    };
    Primary.neutral = {
        black: '#000000',
        grey1: '#1B1B1B',
        grey2: '#404040',
        'grey2.5': '#757575',
        grey3: '#7F7F7F',
        grey4: '#C0C0C0',
        grey5: '#F2F2F2',
        grey6: '#F8F8F8',
        white: '#FFFFFF',
    };
})(Primary || (exports.Primary = Primary = {}));
var Secondary;
(function (Secondary) {
    Secondary.green = {
        '100': '#1AAE52',
        '80': '#48BE75',
        '60': '#76CE97',
        '40': '#A3DFBA',
        '20': '#D1EFDC',
        '10': '#E8F6ED',
        '5': '#F3FBF6',
    };
    Secondary.red = {
        '130': '#AC3240',
        '120': '#C43949',
        '110': '#DD4052',
        '100': '#F5475B',
        '80': '#F76C7C',
        '60': '#F9919D',
        '40': '#FBB5BD',
        '20': '#FDDADE',
        '10': '#FEECEE',
        '5': '#FEF6F7',
    };
    Secondary.yellow = {
        '100': '#F7B500',
        '80': '#F9C433',
        '60': '#FAD366',
        '40': '#FCE199',
        '20': '#FDF0CC',
        '10': '#FEF7E5',
        '5': '#FEFBF2',
    };
    Secondary.blue = {
        '130': '#006B89',
        '120': '#007A9D',
        '110': '#008AB0',
        '100': '#0099C4',
        '80': '#33ADD0',
        '60': '#66C2DC',
        '40': '#99D6E7',
        '20': '#CCEBF3',
        '10': '#E6F5F9',
        '5': '#F2FAFC',
    };
})(Secondary || (exports.Secondary = Secondary = {}));
//# sourceMappingURL=colors.js.map